import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en-US', // 设置回退语言
    // debug: true,
    supportedLngs: ['en-US', 'ja-JP', 'zh-TW'],
    ns: ['translation', 'home', 'chat', 'report', 'feedback', 'setting', 'network'],
    defaultNS: 'translation',

    interpolation: {
      escapeValue: false,
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
